import "material-design-icons-iconfont/dist/material-design-icons.css"; // Ensure you are using css-loader
import "@fortawesome/fontawesome-free/css/all.css"; // Ensure you are using css-loader
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import vuetify from "./plugins/vuetify";
import * as VueGoogleMaps from "vue2-google-maps";
/*import "core-js/es7/object";*/
import "core-js/stable/object";
import "core-js/stable/array/fill";
import "core-js/stable/array/find";

// for production AIzaSyAfT2AfcXzLAfaop9S9imTKqHtxJmOkvgM
Vue.config.productionTip = false;
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAeEZOnkIiBUzEJKwiuQwUks8Nbe5PUmlo",
    libraries: "places", // necessary for places input
  },
});

new Vue({
  router,
  store,
  vuetify,
  VueGoogleMaps,
  render: (h) => h(App),
  icons: {
    iconfont: "fa",
  },
}).$mount("#app");
